import React from 'react'
import classNames from 'classnames'

export const TextInput = ({ className, onChange, ...otherProps }) => (
  <input
    type="text"
    className={ classNames("text-input uk-width-1-1", className) }
    onChange={ event => onChange(event.target.value) } 
    { ...otherProps } />
)


// WEBPACK FOOTER //
// ./src/ui/elements/TextInput.js